import { useState, useCallback } from 'react';

const STORAGE_KEY = 'demo-mode-hide-nav';

export function useDemoMode(): [boolean, (value: boolean) => void] {
    const [demoMode, setDemoModeState] = useState<boolean>(() => {
        try {
            return localStorage.getItem(STORAGE_KEY) === 'true';
        } catch {
            return false;
        }
    });

    const setDemoMode = useCallback((value: boolean) => {
        setDemoModeState(value);
        try {
            localStorage.setItem(STORAGE_KEY, String(value));
        } catch {
            // localStorage unavailable
        }
    }, []);

    return [demoMode, setDemoMode];
}
